<template>
    <div>
        <!-- Footer -->
        <div
            class="footer mt-3"
            :class="isMobile ? 'footer-sm' : 'footer-lg'"
            v-if="$route.path !== '/maung-fb' && $route.path !== '/body-fb'"
        >
            <!-- <img src="/build/assets/img/brand/khit_thit.jpg" alt="" /> -->
            <div class="align-items-center justify-content-lg-between">
                <div class="col-lg-12 text-center">
                    <ul class="nav nav-footer justify-content-between">
                        <li
                            class="nav-item"
                            :class="{ active: linkIsActive('/home') }"
                            @click="$router.push('/home')"
                        >
                            <div class="d-flex flex-column banking-icons">
                                <img
                                    class="mx-auto footer-nav-icon"
                                    src="https://storage.googleapis.com/spacetech2/shwemyanmar/home.png"
                                    alt=""
                                >
                                <div class="mx-auto pt-1 text-sm footer-nav-label">
                                    {{ $t('footer.home') }}
                                </div>
                            </div>
                        </li>
                        <!-- <li
                            class="nav-item"
                            @click="openModal()"
                        >
                            <div class="d-flex flex-column banking-icons">
                                <img class="mx-auto" src="/build/assets/img/icons/Download.png" style="width: 18px; height: 18px" alt="">
                                <div class="mx-auto pt-1 text-sm" style="color: #a486ea;">
                                    {{
                                        $store.state.language === "en"
                                            ? "Download"
                                            : "ဒေါင်းလုတ်"
                                    }}
                                </div>
                            </div>
                        </li> -->
                        <!-- :class="linkIsActive('/deposit') ? 'active' : ''" -->
                        
                        <!-- <li
                            class="nav-item"
                            @click="$router.push('/history')"
                        >
                            <div class="d-flex flex-column banking-icons">
                                <img class="mx-auto" src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/melon-zeed/icons/money-exchange%20(1).png" style="width: auto; height: 1.5rem;" alt="">
                                <div class="mx-auto pt-1 text-sm" style="color: #000000;">
                                    {{$t('setting.transaction')}}
                                </div>
                            </div>
                        </li> -->
                        <li
                            class="nav-item"
                            :class="{ active: linkIsActive('/deposit') }"
                            @click="$router.push('/deposit')"
                        >
                            <div class="d-flex flex-column banking-icons">
                                <img
                                    class="mx-auto footer-nav-icon"
                                    src="https://storage.googleapis.com/spacetech2/shwemyanmar/wallet.png"
                                    alt=""
                                >
                                <div class="mx-auto pt-1 text-sm footer-nav-label">
                                    {{ $t('setting.deposit') }}
                                </div>
                            </div>
                        </li>
                        <li
                            class="nav-item nav-item--buffalo"
                            :class="{ active: isBuffaloSlotActive }"
                            @click="$router.push('/user/slots?provider=Buffalo')"
                        >
                            <div class="d-flex flex-column banking-icons banking-icons--buffalo">
                                <span class="footer-buffalo-fab">
                                    <img
                                        class="footer-buffalo-icon"
                                        src="/assets/AfriBuffalo.webp"
                                        alt="African Buffalo"
                                    >
                                </span>
                                <div class="mx-auto pt-1 text-sm footer-nav-label">
                                    Buffalo
                                </div>
                            </div>
                        </li>
                        <li
                            class="nav-item"
                            :class="{ active: linkIsActive('/withdraw') }"
                            @click="$router.push('/withdraw')"
                        >
                            <div class="d-flex flex-column banking-icons">
                                <img
                                    class="mx-auto footer-nav-icon"
                                    src="https://storage.googleapis.com/spacetech2/shwemyanmar/withdraw.png"
                                    alt=""
                                >
                                <div class="mx-auto pt-1 text-sm footer-nav-label">
                                    {{ $t('setting.withdraw') }}
                                </div>
                            </div>
                        </li>
                        <!-- <li class="nav-item">
                            <a
                                href="https://t.me/Shwekyarphyu_Bot"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <div class="d-flex flex-column banking-icons">
                                    <img
                                        class="mx-auto footer-nav-icon"
                                        src="https://storage.googleapis.com/spacetech2/shwemyanmar/customer-support.png"
                                        alt=""
                                    >
                                    <div class="mx-auto pt-1 text-sm footer-nav-label">
                                        {{ $t('setting.customer_service') }}
                                    </div>
                                </div>
                            </a>
                        </li> -->
                        <li
                            class="nav-item"
                            :class="{ active: linkIsActive('/setting') }"
                            @click="$router.push('/setting')"
                        >
                            <div class="d-flex flex-column banking-icons">
                                <img
                                    class="mx-auto footer-nav-icon"
                                    src="https://storage.googleapis.com/spacetech2/shwemyanmar/settings.png"
                                    alt=""
                                >
                                <div class="mx-auto pt-1 text-sm footer-nav-label">
                                    {{ $t('footer.profile') }}
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Toast, Dialog } from 'vant';

export default {
    data() {
        return {
            is_live: false,
            isMobile: false,
        };
    },
    computed: {
        isBuffaloSlotActive() {
            return (
                this.$route.path === '/user/slots'
                && this.$route.query.provider === 'Buffalo'
            );
        },
    },
    methods: {
        closeModal() {
            $('#download-modal').modal('hide');
        },
        openModal() {
            $('#download-modal').modal('show');
        },
        /* example link = '/settings' */
        linkIsActive(link) {
            if (link === '/home') {
                return this.$route.path === '/' || this.$route.path === '/home';
            }
            return this.$route.path === link;
        },
        updateViewport() {
            this.isMobile = window.innerWidth < 768;
        },
        async fetchFootballLive() {
            try {
                const res = await axios.get('/football-lives');
                this.is_live = res.data.data[0].is_live;
            } catch (error) {
                console.log(error);
            }
        },
    },
    mounted() {
        this.fetchFootballLive();
        this.updateViewport();
        window.addEventListener('resize', this.updateViewport);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateViewport);
    },
};
</script>
<style scoped>
.modal-content {
    border: 2px solid #082612;
}

td .fa-trash {
    color: #0D3B1A;
}

.modal-cross {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    padding-top: 3px;
    margin-left: auto;
    color: white;
    cursor: pointer;
    margin-right: -9px;
    margin-top: -9px;
    background: #0D3B1A;
}

.banking-icons {
    width: auto;
    height: auto;
    padding: 5px;
    border-radius: 5px;
}

.bet-container {
    position: fixed;
    bottom: 0;
    margin-bottom: 50px;
    width: 50px;
    /* right: 0; */
    left: 5px;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0.25em;
    color: white;
    z-index: 100;
    visibility: visible;
    opacity: 1;
}

.nav-item {
    position: relative;
    flex: 1;
    font-size: 1rem;
    cursor: pointer;
    font-weight: 600;
    min-width: 0;
}

/* PNG icons → brand green on white footer */
.footer-nav-icon {
    width: auto;
    height: 1.35rem;
    opacity: 0.75;
    filter: brightness(0) saturate(100%) invert(28%) sepia(42%) saturate(700%) hue-rotate(95deg) brightness(0.95);
    transition: transform 0.2s ease, opacity 0.2s ease, filter 0.2s ease;
}

/* Beat Argon `.footer .nav .nav-item .nav-link` and other globals */
.footer ul.nav-footer .nav-item,
.footer ul.nav-footer .nav-item .footer-nav-label,
.footer ul.nav-footer .nav-item .banking-icons,
.footer ul.nav-footer .nav-item a,
.footer ul.nav-footer .nav-item a:visited,
.footer ul.nav-footer .nav-item a .footer-nav-label {
    color: rgba(26, 46, 31, 0.72) !important;
    text-decoration: none !important;
}

.footer-nav-label {
    font-size: 0.65rem !important;
    font-weight: 600;
    line-height: 1;
    transition: color 0.2s ease;
}

.footer ul.nav-footer .nav-item.active .footer-nav-label {
    color: #0D3B1A !important;
}

.footer .nav-item.active .footer-nav-icon {
    opacity: 1;
    filter: brightness(0) saturate(100%) invert(14%) sepia(42%) saturate(900%) hue-rotate(105deg) brightness(0.92) contrast(1.15);
    transform: translateY(-2px);
}

.footer .nav-item.active::before {
    position: absolute;
    top: -1px;
    left: 50%;
    width: 1.7rem;
    height: 3px;
    border-radius: 0 0 999px 999px;
    background: #0D3B1A;
    box-shadow: 0 2px 10px rgba(13, 59, 26, 0.55);
    content: "";
    transform: translateX(-50%);
}

.footer .nav-item--buffalo.active::before {
    display: none;
}

.nav-item--buffalo {
    z-index: 2;
}

.banking-icons--buffalo {
    padding-top: 0 !important;
}

.footer-buffalo-fab {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 3.35rem;
    height: 3.35rem;
    margin: -1.35rem auto 0;
    border-radius: 50%;
    background: linear-gradient(160deg, #0D3B1A 0%, #145224 100%);
    border: 3px solid #FFFFFF;
    box-shadow: 0 6px 16px rgba(8, 38, 18, 0.28);
    overflow: hidden;
}

.footer-buffalo-icon {
    width: 2.35rem;
    height: 2.35rem;
    object-fit: contain;
    filter: none !important;
    opacity: 1 !important;
}

.footer .nav-item--buffalo.active .footer-buffalo-fab {
    box-shadow: 0 0 0 2px #E8B923, 0 6px 16px rgba(8, 38, 18, 0.28);
}

.footer .nav-item--buffalo .footer-nav-label {
    margin-top: 0.15rem;
}

.footer ul.nav-footer .nav-item a:hover,
.footer ul.nav-footer .nav-item a:hover .footer-nav-label {
    color: #1A2E1F !important;
}

.footer {
    bottom: 0;
    height: 4.15rem !important;
    width: 100%;
    background: #FFFFFF;
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
    box-shadow: 0 -6px 22px rgba(26, 46, 31, 0.08);
    border-top: 1px solid rgba(13, 59, 26, 0.22);
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
    overflow: visible;
}

.footer-sm,
.footer-lg {
    /* Stay inside the centered phone shell on PC (not full viewport) */
    position: absolute;
    left: 0;
    right: 0;
}

@media (max-width: 767.98px) {
    .footer-sm {
        position: fixed;
    }
}

.banking-icons {
    width: auto;
    height: auto;
    padding: 0.2rem;
    padding-top: 0.55rem;
    padding-bottom: 0.4rem;
    border-radius: 3px;
    transition: transform 0.2s ease;
}

.nav-item:active .banking-icons {
    transform: scale(0.94);
}

.footer {
    padding: 1px !important;
}

/* .banking-icons img {
        width: 25px;
        height: 25px;
        border-radius: 3px;
    } */
/* } */
</style>
